import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import {
  AddLinkRounded,
  DashboardRounded,
  LoopRounded,
  QueuePlayNextRounded,
  SecurityRounded,
} from '@mui/icons-material';
import { TabletSmartphoneIcon } from 'lucide-react';

const items = [
  {
    icon: <LoopRounded />,
    title: 'Full-Stack Web & Cloud Application Development',
    description:
      'Design, develop, and deploy scalable cloud-native web applications and serverless architectures.',
  },
  {
    icon: <TabletSmartphoneIcon />,
    title: 'Mobile App Development (iOS & Android)',
    description:
      'Build high-performance native and cross-platform mobile apps with seamless backend integrations.',
  },
  {
    icon: <QueuePlayNextRounded />,
    title: 'Desktop Application Development',
    description:
      'Develop robust Windows, macOS, and Linux applications for enterprise and consumer use.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'DevOps, Automation & CI/CD Implementation',
    description:
      'Implement continuous integration and deployment (CI/CD) pipelines with Docker, Kubernetes, and Terraform for faster and reliable software delivery.',
  },
  {
    icon: <AddLinkRounded />,
    title: 'API Development & System Integrations',
    description:
      'Build secure and scalable RESTful & GraphQL APIs for seamless third-party integrations and microservices architecture.',
  },
  {
    icon: <SecurityRounded />,
    title: 'Security & Identity Management Solutions',
    description:
      'Implement MFA, passwordless authentication, and role-based access controls (RBAC) for enterprise-grade security in applications.',
  },
  {
    icon: <DashboardRounded />,
    title: 'ERP & CRM',
    description:
      'Implement, customize, and integrate ERP and CRM systems for Salesforce and NetSuite',
  },
];

export default function Service() {
  return (
    <Box
      id="services"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Services
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            FalconXcellence provides end-to-end development solutions, including cloud and web
            applications, mobile and desktop software, game development, DevOps automation, and
            seamless API integrations to build scalable, high-performance digital experiences.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
